import React from "react";
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { Typography } from "@mui/material";


interface OrderDetailsProps {
}

const OrderDetails: React.FC<OrderDetailsProps> = ({
}) => {

  const steps = [
    'Confirm order details',
    'Payment',
    'Order Confirmed',
    'Order Sent',
  ];


  return (
    <>
      <Stepper activeStep={1} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

    </>
  );
};

export default OrderDetails;
